import {ADataGridColors} from '@atiautomacao/ati-ui-library';

export const INHIBITED_STATUS_COLOR = '#F25C2A';

export const formatInhibitedStatus = (
    inhibited?: boolean | null,
    operationalStatus?: string,
): string | undefined => {
    if (!inhibited) {
        return operationalStatus;
    }
    return operationalStatus ? `Inibido · ${operationalStatus}` : 'Inibido';
};

export const getInhibitedDataGridColors = (): ADataGridColors => ({
    color: '#FFFFFF',
    backgroundColor: INHIBITED_STATUS_COLOR,
});

type EquipmentTeleObjectRow = {
    inhibited?: boolean;
    status?: string;
    telemetryStatus?: string;
};

export const getEquipmentTeleObjectColors = (
    row: EquipmentTeleObjectRow,
): ADataGridColors => {
    if (row.inhibited === true) {
        return getInhibitedDataGridColors();
    }
    const operationalStatus = row.telemetryStatus || row.status;
    if (operationalStatus?.toLowerCase().includes('alarmado')) {
        return {
            color: '',
            backgroundColor: '#F85F4E',
        };
    }
    return {
        color: '',
        backgroundColor: '',
    };
};
